import * as React from 'react';
import { Button as AriaButton } from 'react-aria-components';
import styles from './AtollonButton.module.css';

export enum AtollonButtonDesignType {
    SUBTLE = 'subtle',
    PRIMARY = 'primary',
    NEGATIVE_SUBTLE = 'negative-subtle',
    NEGATIVE_PRIMARY = 'negative-primary',
    POSITIVE_SUBTLE = 'positive-subtle',
    POSITIVE_PRIMARY = 'positive-primary',
    OUTLINE = 'outline',
    LINK = 'link',
    LINK_NEGATIVE = 'link-negative',
    LINK_POSITIVE = 'link-positive',
}
export interface IAtollonButtonProps {
    children: React.ReactNode;
    onPress?: () => void;
    isDisabled?: boolean;
    isPending?: boolean;
    designType: AtollonButtonDesignType ;
}

export function AtollonButton (props: IAtollonButtonProps) {
    var className = styles.atollonButton;
    if (props.designType) {
        className += ` ${styles[props.designType]}`;
    }

  return (
    <AriaButton onPress={props.onPress} isDisabled={props.isDisabled} isPending={props.isPending} className={className}>
        {props.children}
    </AriaButton>
  );
}
